import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect, useState } from 'react';

import { Button, Col, Form, Input, Modal, Row, Spin, Table, TableColumnsType } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { getKrConfirmCompleteQuarter, reset, saveCompleteQuarter } from 'app/entities/checkIn/checkIn.reducer';
import { displayPercent } from 'app/shared/util/percent';
import { Container } from 'reactstrap';
import * as _ from 'lodash';
import '../style.scss';

type IConfirmCompleteProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  isShow?: boolean;
};

export const ConfirmCompleteQuarter = ({ isOpen, isShow = true, onClose }: IConfirmCompleteProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const updating = useAppSelector(state => state.checkIn.updating);
  const loading = useAppSelector(state => state.checkIn.loading);
  const updateSuccess = useAppSelector(state => state.checkIn.updateSuccess);

  const [data, setData] = useState(null);

  const columnsResult: TableColumnsType<any> = [
    {
      key: 'workStatusName',
      dataIndex: 'workStatusName',
      width: 200,
    },
    {
      title: 'Số KR',
      key: 'quarterCount',
      align: 'center',
      dataIndex: 'quarterCount',
    },
    {
      title: 'Tỷ lệ',
      key: 'quarterProportion',
      align: 'center',
      dataIndex: 'quarterProportion',
      render: item => `${displayPercent(item).toFixed(2)}%`,
    },
  ];

  useEffect(() => {
    if (filters?.planPeriodId) innitData();
  }, [filters]);

  const innitData = async () => {
    const response = await dispatch(
      getKrConfirmCompleteQuarter(filters?.accountableId),
    );
    if (response && response.payload) {
      const result = response.payload as any;
      if (result.data) {
        setData(result.data);
        form.setFieldsValue({
          ...result.data,
          outstandingResults: result.data?.outstandingResults?.map(item => ({ outstandingResult: item })),
          adjustmentNotes: result.data?.adjustmentNotes?.map(item => ({ adjustmentNote: item })),
          issues: result.data?.issues?.map(item => ({ issues: item })),
          proposals: result.data?.proposals?.map(item => ({ proposal: item })),
        });
      }
    }
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose(updateSuccess);
    }
  }, [updateSuccess]);

  const mapperDataPayload = (values, isDraft = false) => {
    const payload = {
      ...values,
      partyId: filters?.accountableId,
      outstandingResults: values.outstandingResults?.map(item => item.outstandingResult),
      adjustmentNotes: values.adjustmentNotes?.map(item => item.adjustmentNote),
      issues: values.issues?.map(item => item.issues),
      proposals: values.proposals?.map(item => item.proposal),
      isDraft,
    };
    return payload;
  }

  const handleSubmit = values => {
    const payload = mapperDataPayload(values);
    dispatch(saveCompleteQuarter(payload));
  };

  const handleSaveDraft = () => {
    form.validateFields().then(values => {
      const payload = mapperDataPayload(values, true);
      dispatch(saveCompleteQuarter(payload));
    }).catch(() => { return; });
  };

  const handleClose = (reload = false) => {
    onClose(reload);
    dispatch(reset())
  };

  return (
    <Modal
      width={1150}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Spin spinning={loading} delay={300}>
          <Form initialValues={{
            outstandingResults: [{}],
            proposals: [{}],
            issues: [{}],
            adjustmentNotes: [{}],
            essentials: [{}]
          }} size="large" form={form} onFinish={handleSubmit} layout="vertical">
            <Title level={3}>{`Xác nhận hoàn thành check in ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
            <Row>
              <Col>
                <Form.Item label="Kỳ báo cáo">
                  <Input disabled value={data?.reportScheduleName} />
                </Form.Item>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h5">I. KẾT QUẢ THỰC HIỆN MỤC TIÊU {data?.reportScheduleName}</span>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h6">1. Tổng hợp kết quả thực hiện</span>
              </Col>
            </Row>
            <Row>
              <Col md={24}>
                <Table
                  pagination={false}
                  bordered
                  dataSource={data?.workLoads}
                  columns={columnsResult}
                  className="w-100"
                  rowClassName={(record, index) => {
                    return index === data?.workLoads.length - 1 ? 'fw-bold' : '';
                  }}
                />
              </Col>
            </Row>

            <Row className='my-3'>
              <Col md={17}>
                <span className="fw-bold h6">{`2. Điểm đánh giá hoàn thành mục tiêu ${' '}  ${' '}   ${' '}${_.isInteger(displayPercent(data?.quarterRating ?? 0)) ? `${displayPercent(data?.quarterRating ?? 0)}%` :
                  `${displayPercent(data?.quarterRating ?? 0).toFixed(2)}%`
                  }`}</span>
              </Col>
            </Row>
            {isShow &&
              <>
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h6">3. Đánh giá chung</span>
                  </Col>
                </Row>
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h7">a. Kết quả nổi bật</span>
                  </Col>
                </Row>
                <Form.List name="outstandingResults">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row key={key} className='my-3'>
                          <Col md={23}>
                            <div className='multiple-row-add'>
                              <Form.Item
                                {...restField}
                                name={[name, 'outstandingResult']}
                              >
                                <TextArea className='w-100' rows={2} placeholder="Tổng hợp lại những đánh giá chung nhất về kết quả thực hiện mục tiêu trong kỳ báo cáo, không cần nêu lại chi tiết các KR" />
                              </Form.Item>
                              <MinusCircleOutlined className='minus-circle' onClick={() => remove(name)} />
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} />
                    </>
                  )}
                </Form.List>
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h7">b. Tồn tại trọng yếu</span>
                  </Col>
                </Row>
                <Row className='my-3'>
                  <Col md={23}>
                    <Row>
                      <Col md={5}>
                        <span className="fw-bold">Tồn tại</span>
                      </Col>
                      <Col md={1} />
                      <Col md={5}>
                        <span className="fw-bold">Khó khăn, Nguyên nhân</span>
                      </Col>
                      <Col md={1} />
                      <Col md={5}>
                        <span className="fw-bold">Giải pháp</span>
                      </Col>
                      <Col md={1} />
                      <Col md={5}>
                        <span className="fw-bold">Kiến nghị</span>
                      </Col>
                    </Row>
                  </Col>

                </Row>
                <Form.List name="essentials">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row key={key} className='my-3'>
                          <Col md={23}>
                            <div className='multiple-row-add'>
                              <Row>
                                <Col md={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'backLog']}
                                  >
                                    <TextArea className='w-100' rows={2} />
                                  </Form.Item>
                                </Col>
                                <Col md={1} />
                                <Col md={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'issue']}
                                  >
                                    <TextArea className='w-100' rows={2} />
                                  </Form.Item>
                                </Col>
                                <Col md={1} />
                                <Col md={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'solution']}
                                  >
                                    <TextArea className='w-100' rows={2} />
                                  </Form.Item>
                                </Col>
                                <Col md={1} />
                                <Col md={5}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'proposal']}
                                  >
                                    <TextArea className='w-100' rows={2} />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <MinusCircleOutlined className='minus-circle' onClick={() => remove(name)} />
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} />
                    </>
                  )}
                </Form.List>
                <hr />
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h5">II. MỤC TIÊU TRỌNG TÂM QUÝ {_.upperFirst(data?.nextQuarterName)}</span>
                  </Col>
                </Row>
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h6">1. Những mục tiêu chính</span>
                  </Col>
                </Row>
                <Form.List name="adjustmentNotes">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row key={key} className='my-3'>
                          <Col md={23}>
                            <div className='multiple-row-add'>
                              <Form.Item
                                {...restField}
                                name={[name, 'adjustmentNote']}
                              >
                                <TextArea className='w-100' rows={2} placeholder="Nêu khái quát các mục tiêu và KR quan trọng nhất của đơn vị cần thực hiện trong quý 4, không cần nêu lại chi tiết các mục " />
                              </Form.Item>
                              <MinusCircleOutlined className='minus-circle' onClick={() => remove(name)} />
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} />
                    </>
                  )}
                </Form.List>
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h6">2. Khó khăn, nguyên nhân và giải pháp khắc phục</span>
                  </Col>
                </Row>
                <Form.List name="issues">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row key={key} className='my-3'>
                          <Col md={23}>
                            <div className='multiple-row-add'>
                              <Form.Item
                                {...restField}
                                name={[name, 'issues']}
                              >
                                <TextArea className='w-100' rows={2} />
                              </Form.Item>
                              <MinusCircleOutlined className='minus-circle' onClick={() => remove(name)} />
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} />
                    </>
                  )}
                </Form.List>
                <hr />
                <Row className='my-3'>
                  <Col md={24}>
                    <span className="fw-bold h5">III. KIẾN NGHỊ, ĐỀ XUẤT</span>
                  </Col>
                </Row>
                <Form.List name="proposals">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row key={key} className='my-3'>
                          <Col md={23}>
                            <div className='multiple-row-add'>
                              <Form.Item
                                {...restField}
                                name={[name, 'proposal']}
                              >
                                <TextArea className='w-100' rows={2} />
                              </Form.Item>
                              <MinusCircleOutlined className='minus-circle' onClick={() => remove(name)} />
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} />
                    </>
                  )}
                </Form.List>
              </>
            }
            <Form.Item>
              <Row className="action" justify="end">
                <Col>
                  <Button
                    className="green"
                    onClick={() => {
                      handleSaveDraft();
                    }}
                    disabled={updating}
                  >
                    Lưu nháp
                  </Button>
                </Col>
                <Col>
                  <Button type="primary" htmlType="submit" disabled={updating}>
                    Xác nhận hoàn thành
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Hủy
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Container>
    </Modal>
  );
};

export default ConfirmCompleteQuarter;
